import React from 'react';
import { 
  Stethoscope, 
  Calculator, 
  FileText, 
  Building2, 
  Receipt, 
  CreditCard, 
  UserCheck 
} from 'lucide-react';
import { useCounterAnimation } from '../hooks/useCounterAnimation';
import './Home.css';

const Home = () => {
  const [empresasCount, empresasRef] = useCounterAnimation(100, 2000);
  const [anosCount, anosRef] = useCounterAnimation(6, 2000);
  const [clientesCount, clientesRef] = useCounterAnimation(99, 2000);
  const [suporteCount, suporteRef] = useCounterAnimation(24, 2000);

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-container">
          <div className="hero-content">
            <h1 className="hero-title">
              Você médico paga muito <span className="highlight">imposto</span>?
            </h1>
            <p className="hero-subtitle">
              Descubra como economizar com planejamento tributário e tenha o retorno sobre todos os impostos que você paga.
            </p>
            <div className="hero-buttons">
              <button className="btn-primary" onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}>Conhecer Serviços</button>
              <button className="btn-secondary" onClick={() => window.open(`https://wa.me/${"5543998258921"}?text=${encodeURIComponent("Olá! Gostaria de saber mais sobre os serviços de contabilidade.")}`, '_blank')}>Falar com Especialista</button>
            </div>
          </div>
          <div className="hero-image">
            <div className="hero-graphic">
              <div className="graphic-circle"></div>
              <div className="graphic-square"></div>
              <div className="graphic-triangle"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services" id="services">
        <div className="container">
          <h2 className="section-title">Nossos Serviços</h2>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">
                <Stethoscope size={40} color="currentColor" />
              </div>
              <h3>Contabilidade para profissionais da saúde</h3>
              <p>Gestão completa dos processos contábeis com tecnologia de ponta e equipe especializada.</p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <Calculator size={40} color="currentColor" />
              </div>
              <h3>Consultoria Fiscal</h3>
              <p>Otimização tributária e consultoria especializada para reduzir custos e aumentar lucros.</p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <FileText size={40} color="currentColor" />
              </div>
              <h3>Folha de Pagamento</h3>
              <p>Processamento completo da folha com cálculos precisos e entrega dentro dos prazos.</p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <Building2 size={40} color="currentColor" />
              </div>
              <h3>Abertura CNPJ</h3>
              <p>Abertura de um CNPJ permite que você atue de forma legal.</p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <Receipt size={40} color="currentColor" />
              </div>
              <h3>Regime Tributário</h3>
              <p>Definir o regime tributário correto, evita carga tributária em excesso.</p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <Receipt size={40} color="currentColor" />
              </div>
              <h3>Notas Fiscais</h3>
              <p>Emissão de notas fiscais é obrigatório e garante a legalidade do serviço.</p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <CreditCard size={40} color="currentColor" />
              </div>
              <h3>Despesas</h3>
              <p>Organizar as despesas evita problema no fluxo de caixa.</p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <UserCheck size={40} color="currentColor" />
              </div>
              <h3>Profissional Contábil</h3>
              <p>A escolha de um profissional contábil que entenda da área, evita cobranças indevidas e oferece suporte estratégico.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item" ref={empresasRef}>
              <h3>{empresasCount}+</h3>
              <p>Empresas Atendidas</p>
            </div>
            <div className="stat-item" ref={anosRef}>
              <h3>{anosCount}+</h3>
              <p>Anos de Experiência</p>
            </div>
            <div className="stat-item" ref={clientesRef}>
              <h3>{clientesCount}%</h3>
              <p>Clientes Satisfeitos</p>
            </div>
            <div className="stat-item" ref={suporteRef}>
              <h3>{suporteCount}/7</h3>
              <p>Suporte Disponível</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <div className="container">
          <div className="cta-content">
            <h2>Profissional da saúde</h2>
            <p>Aprenda a definir seu pró-labore e evite tributos em excesso. A Gestare te ajuda, entre em contato conosco.</p>
            <button className="btn-primary" onClick={() => window.open(`https://wa.me/${"5543998258921"}?text=${encodeURIComponent("Olá! Gostaria de saber mais sobre os serviços de contabilidade.")}`, '_blank')}>Fale conosco</button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
